import React from "react";
import styled from "styled-components";
import constants from "./constants";

const Input = styled.input`
  ${constants.nonExportedCss};

  border: 1px solid black;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.colors
      ? uiKitConfiguration.colors["color-gray-400"]
      : constants.defaults.input.borderColor;
  }};
  color: black;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 7px;
  border-radius: ${({ uiKitConfiguration }) => {
    if (uiKitConfiguration.border_radius) {
      return Math.min(
        uiKitConfiguration.border_radius,
        constants.maxValues.input.borderRadius,
      );
    } else {
      return constants.defaults.input.borderRadius;
    }
  }}px;
`;

export default Input;
